<template>
  <div class="course-box" v-if="courses.length > 0">
    <!-- 指定标题且存在课程数据时才显示标题 -->
    <div class="course-title" v-if="title">
      <van-image :src="require('@/assets/icons/migu.png')" show-error show-loading />
      <span>{{ title }}</span>
    </div>

    <!-- 课程列表 -->
    <ul :class="listClass">
      <li
        v-for="(course, index) in courses"
        :key="index"
        @click="toDetail(course)"
      >
        <div class="course" v-if="listClass === 'columns'">
          <div class="course-hd">
            <van-image class="course-img" :src="course.bigLogoImg" show-error show-loading />
            <div class="course-playbtn" v-if="course.videoDesc">
              <img src="@/assets/icons/play.png" />
            </div>
          </div>
          <div class="course-bd">
            <p class="course-bd--title">{{ course.title }}</p>
          </div>
        </div>
        <div class="course" v-else>
          <van-image v-if="listClass === 'gallery'" class="course-img" :src="course.smallLogoImg" show-error show-loading />
          <van-image v-else class="cover" :src="course.smallLogoImg" show-error show-loading />
          <!-- <van-image v-if="course.tag" class="tag" :src="course.tag" show-error show-loading /> -->
          <div class="intro" v-if="listClass === 'gallery'">
            <p class="title">{{ course.title }}</p>
            <p class="desc">{{ course.itemNum }}节 | {{ course.totalLength }}分钟</p>
            <p class="course-bd--hot">{{ course.salesNum }} 人已购</p>
          </div>
          <div class="intro" v-else>
            <p class="title">{{ course.title.length > 10 ? `${course.title.substring(0, 10)}..`:course.title}}</p>
            <p class="desc">{{ course.subTitle }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Course',
  props: {
    index: Number,
    title: String,
    showType: String,
    courses: {
      type: Array,
      required: true
    },
    invitationCode: {
      type: String
    }
  },
  mounted() {
    console.log(`invitationCode2 --${this.invitationCode}`)
  },
  computed: {
    listClass: function() {
      if (this.showType) {
        // 正行模式
        if (this.showType === 'one') {
          return 'columns'
        } else if (this.showType === 'two') {
          return 'rows'
        } else {
          return 'gallery'
        }
      } else {
        return 'rows'
      }
    }
  },
  methods: {
    toDetail(course) {
      switch (course.buyStatus) {
        case 'own_subject':
          this.$router.push({
            name: 'learn',
            query: { id: course.id }
          })
          break
        case 'pink_buying':
          this.$router.replace({
            name: 'classroom'
          })
          break
        case 'not_buy':
          const self = this
          this.$router.push({
            name: 'subject',
            query: {
              id: course.id,
              invitationCode: self.invitationCode
            }
          })
          break
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/variables.scss";
// 课程样式
.course-box {
  padding-bottom: 40px;
  .course-title {
    display: flex;
    align-items: center;
    padding-bottom: 3px;
    // border-bottom: 3px double rgba(188, 188, 188, 0.4);
    img {
      width: 19px;
      height: 25px;
    }
    span {
      margin-left: 7.86px;
      font-size: 22px;
      font-weight: bold;
      color: #373737;
    }
  }

  // 画廊模式
  & > .gallery {
    .course {
      margin-top: 15px;
      display: flex;
      background-color: #FFFFFF;
      padding: 15px;
      border-radius: 12px;
      box-shadow: 0px 0px 10px #CCCCCC;
      .course-img {
        margin-top: 10px;
        position: relative;
        width: 97px;
        height: 97px;
        margin-right: 15px;
        border-radius: 12px;
        overflow: hidden;
        /*box-shadow: 3px 3px 2px $dividerColor;*/
      }
      .intro {
        flex: 1;
        .course-bd--btn {
          padding-top: 20px;
          &:after {
            content: "";
            clear: both;
            display: table;
          }
          .van-button {
            float: right;
            height: 30px;
            line-height: 30px;
            font-size: 13px;
          }
        }
        .course-bd--hot {
          font-size: 12px;
          color: #9b9b9b;
          padding-top: 40px;
        }
        & > .title {
          font-size: 16px;
          font-weight: bold;
          color: #4c4c4c;
          padding-top: 7.5px;
        }
        & > .desc {
          font-size: 12px;
          color: #9b9b9b;
          padding-top: 7.5px;
          word-wrap:break-word;
        }
      }
    }
  }

  // 准备删除
  & > .rows {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 15px;
    background-color: #FFFFFF;
    padding: 15px;
    border-radius: 12px;
    box-shadow: 0px 0px 10px #CCCCCC;
    .course {
      margin-top: 15px;
      .cover {
        width: 140px;
        height: 140px;
        border-radius: 12px;
        overflow: hidden;
        /*box-shadow: 3px 3px 2px $dividerColor;*/
        img {
          width: 100%;
          height: 100%;
        }
      }
      .tag {
        position: absolute;
        top: 0;
        left: 0;
        img {
          width: 80px;
          height: 36px;
        }
      }
      .intro {
        & > .title {
          width: 145px;
          padding-top: 12px;
          font-size: 16px;
          color: #4c4c4c;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        & > .desc {
          width: 145px;
          padding-top: 6px;
          font-size: 12px;
          color: #9b9b9b;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  & > .columns {
    .course {
      position: relative;
      margin-top: 15px;
      background-color: #FFFFFF;
      padding: 15px;
      border-radius: 12px;
      box-shadow: 0px 0px 10px #CCCCCC;
      .course-hd {
        width: 100%;
        border-radius: 12px;
        overflow: hidden;
        .course-img {
          width: 100%;
          height: 100%;
        }
      }
      .course-playbtn {
        position: absolute;
        right: 7px;
        bottom: 9px;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .course-bd {
        flex: 1;
        .course-bd--title {
          font-size: 16px;
          font-weight: bold;
          color: #4c4c4c;
          padding-top: 7.5px;
        }
        .course-bd--desc {
          font-size: 12px;
          color: #9b9b9b;
          padding-top: 7.5px;
        }
        .course-bd--hot {
          font-size: 12px;
          color: #9b9b9b;
          padding-top: 7.5px;
        }
      }
    }
    .van-count-down {
      display: inline;
      margin-left: 5px;
      color: #ff4800;
      font-weight: bold;
      font-size: 15px;
    }
    .course-bd--btn {
      padding-top: 20px;
      &:after {
        content: "";
        clear: both;
        display: table;
      }
      .van-button {
        float: right;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
      }
    }
  }
}
</style>
